import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

import { untilDestroyed, UrlParamsService } from '@app/core';
import { User } from '@app/models';
import { UserService, AuthenticationService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-mobile-header-menu',
  templateUrl: './mobile-header-menu.component.html',
  styleUrls: ['./mobile-header-menu.component.scss'],
  standalone: false
})
export class MobileHeaderMenuComponent implements OnInit, OnDestroy {
  @Input() backButtonText = '';
  currentUser: User;
  @ViewChild(NgbDropdown, { static: false }) private dropdown: NgbDropdown;

  constructor(
    public urlParamsService: UrlParamsService,
    public userService: UserService,
    public translateService: TranslateService,
    private location: Location,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.backButtonText = this.backButtonText || this.translateService.instant('button.back');

    this.userService
      .watchCurrentUser()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: user => (this.currentUser = user)
      });
  }

  ngOnDestroy() {}

  backClicked() {
    this.location.back();
  }

  logout() {
    this.authenticationService.logout().subscribe({
      next: () => this.router.navigate(['/entrar'], { replaceUrl: true })
    });
  }
}
